import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classnames from 'classnames2';
import React from 'react';
import { CheckboxIndicator } from './CheckboxIndicator';
import styles from './Checkbox.scss';

function createCheckbox(displayName, labelSizeStyle) {
  var CheckboxBase = function CheckboxBase(props) {
    var _classnames;

    return React.createElement("label", {
      className: classnames(styles.label, labelSizeStyle, (_classnames = {}, _defineProperty(_classnames, styles.labelSelected, props.checked), _defineProperty(_classnames, styles.labelDisabled, props.disabled), _classnames)),
      "data-test": props.dataTest
    }, React.createElement("input", {
      type: "checkbox",
      className: styles.input,
      checked: props.checked,
      disabled: props.disabled,
      onChange: props.onChange,
      role: "checkbox",
      "aria-checked": props.checked
    }), React.createElement(CheckboxIndicator, {
      checked: props.checked,
      color: props.color ? props.color : null
    }), props.label);
  };

  CheckboxBase.displayName = displayName;
  return CheckboxBase;
}

var DefaultCheckbox = createCheckbox('Checkbox.Default', styles.labelDefault);
export var Checkbox = Object.assign(DefaultCheckbox, {
  Default: DefaultCheckbox,
  Small: createCheckbox('Checkbox.Small', styles.labelSmall)
});